<template>
  <div class="offline-progress">
    <div class="card">
      <div class="card-header">
        <span class="card-title">面授学习进度</span>
      </div>
      <div class="flex menu-bar">
        <div class="flex gap12">
          <div style="flex-shrink: 0;">课程名称</div>
          <el-input v-model="trainingName" clearable placeholder="请输入课程名称"></el-input>
        </div>
        <div class="flex">
          <el-button size="mini" icon="el-icon-search" type="warning" @click="search">搜索</el-button>
          <el-button size="mini" icon="el-icon-search" @click="reset">重置</el-button>
        </div>
      </div>
      <div class="card-body">
        <el-table :data="progressList" border :header-cell-style="{background: '#fff6e8',color: '#515a6e'}">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="trainingTitle" label="培训标题" align="center">
            <template slot-scope="scope">
              {{ scope.row.trainingTitle || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="trainingName" label="课程名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.trainingName || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="beginTime" label="上课时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.beginTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="下课时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.endTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="studentClassStartTime" label="学员上课时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.studentClassStartTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="studentClassEndTime" label="学员下课时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.studentClassEndTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="isLate" label="迟到" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isLate ? 'danger' : 'success'">{{ scope.row.isLate ? '是' : '否' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="isEarly" label="早退" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isEarly ? 'danger' : 'success'">{{ scope.row.isEarly ? '是' : '否' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="问卷反馈" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.hasFeedback" class="action-button" type="warning" size="mini" @click="viewFeedback(scope.row)">查看</el-button>
              <el-button v-else class="action-button" type="warning" size="mini" @click="fillFeedback(scope.row)">填写</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="classHours" label="课程学时" align="center">
            <template slot-scope="scope">
              {{ scope.row.classHours || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="acquiredClassHours" label="获得学时" align="center">
            <template slot-scope="scope">
              {{ scope.row.acquiredClassHours||'-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {studyProgressList} from '@/api/course.js'
export default {
  data() {
    return {
      trainingName:'',
      progressList: [],
      currentPage: 1,
      total: 0
    }
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      studyProgressList({
        current:this.currentPage,
        size:10,
        trainingType:'面授',
        trainingName:this.trainingName
      }).then(res=>{
        this.total=res.data.data.total
        if(res.data.code==200){
          this.progressList=res.data.data.records.map(v=>{
            return{
              ...v,
              ...v.trainingListEntity
            }
          })
        }
        // console.log(res)
      })
    },
    
    search() {
      this.currentPage=1
      this.getList()
    },
    reset() {
      this.trainingName = ''
    },
    viewFeedback(item) {
      this.$message.info(`查看《${item.trainingName}》的问卷反馈`)
    },
    fillFeedback(item) {
      this.$message.info(`填写《${item.trainingName}》的问卷反馈`)
    },
    handleSizeChange(index) {
    },
    handleCurrentChange(index) {
      if(this.currentPage!=index){
        this.currentPage = index
        this.getList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.menu-bar{
  font-size: 14px;
  color: #606266;
  gap:21px;
}
.gap12{
  gap:12px;
}
.offline-progress {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }
  }
  .card-body{
    margin-top:16px;
  }
}
.pages {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}

::v-deep .el-pager li.active {
  color: #ED9D26;
}
</style>
